import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import './styles.css'; // Backstage UI, new

import {
  configApiRef,
  useApi,
  microsoftAuthApiRef,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      if (configApi.getString('auth.environment') === 'guest') {
        return (
          <SignInPage
            {...props}
            providers={[
              'guest',
              {
                id: 'microsoft',
                title: 'Microsoft',
                message: 'Sign in using your Microsoft account',
                apiRef: microsoftAuthApiRef,
              },
            ]}
          />
        );
      }

      return (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft',
            title: 'Microsoft',
            message: 'Sign in using your Microsoft account',
            apiRef: microsoftAuthApiRef,
          }}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
